import { useContext, useEffect } from "react";
import { filterInputs } from "../../consts/inputs";
import { toIcons } from "../../consts/Paths";
import FilterContext from "../../context/FilterContext";
import useIsMobile from "../../hooks/useIsMobile";
import useToggle from "../../hooks/useToggle";
import { getInputs } from "../../utils/getMethods";
import CustomInput from "../inputs/CustomInput";

const ModelsFilter = (props: any) => {
  const { isMobile } = useIsMobile();

  const { categoriesToggler, featuresToggler, placeToggler } = props;

  const filterCTX = useContext(FilterContext);

  const inputsFeaturesRange = getInputs(filterInputs, [], "range");
  const renderFeaturesRange = inputsFeaturesRange.map((input, key) => {
    let min = input.constraints?.min;
    let max = input.constraints?.max;

    Object.entries(filterCTX.params).forEach(([a, b]) => {
      if (input.name && a.includes(input.name + "_min")) {
        min = b;
      }
      if (input.name && a.includes(input.name + "_max")) {
        max = b;
      }
    });

    return (
      <CustomInput
        width={isMobile ? 300 : 170}
        key={key}
        {...input}
        startingValue={{ min, max }}
        register={props.byParamsForm.register}
        errors={props.byParamsForm.errors}
        setValue={props.byParamsForm.setValue}
        constraints={input.constraints}
        others={{ resetFiltersToggler: props.resetFiltersToggler }}
      />
    );
  });
  const inputsFeaturesEyes = getInputs(filterInputs, ["eyes"])[0];
  const renderFeaturesEyes = inputsFeaturesEyes.fields!.map((input, key) => {
    let startingValue = "";

    Object.entries(filterCTX.traits).forEach(([a, b]) => {
      if (a == input.name) {
        startingValue = b;
      }
    });

    return (
      <CustomInput
        key={key}
        {...input}
        defaultValue={startingValue}
        others={{
          setAction: props.byTraitsSetAction,
          selectAllToggler: props.selectAllEyesToggler,
          resetToggler: props.resetFiltersToggler,
        }}
      />
    );
  });
  const inputsFeaturesHair = getInputs(filterInputs, ["hair"])[0];
  const renderFeaturesHair = inputsFeaturesHair.fields!.map((input, key) => {
    let startingValue = "";

    Object.entries(filterCTX.traits).forEach(([a, b]) => {
      if (a == input.name) {
        startingValue = b;
      }
    });

    return (
      <CustomInput
        key={key}
        {...input}
        defaultValue={startingValue}
        others={{
          setAction: props.byTraitsSetAction,
          selectAllToggler: props.selectAllHairToggler,
          resetToggler: props.resetFiltersToggler,
        }}
      />
    );
  });

  const inputsFeaturesCategories = getInputs(filterInputs, ["categories"])[0];
  const renderFeaturesCategories = inputsFeaturesCategories.fields!.map(
    (input, key) => {
      let min = input.constraints?.min;
      let max = input.constraints?.max;

      Object.entries(filterCTX.categories).forEach(([a, b]) => {
        if (input.name && a.includes(input.name + "_min")) {
          min = b;
        }
        if (input.name && a.includes(input.name + "_max")) {
          max = b;
        }
      });

      return (
        <CustomInput
          width={isMobile ? 300 : 170}
          key={key}
          {...input}
          register={props.byCategoriesForm.register}
          errors={props.byCategoriesForm.errors}
          setValue={props.byCategoriesForm.setValue}
          getValues={props.byCategoriesForm.getValues}
          startingValue={{ min, max }}
          constraints={input.constraints}
          others={{ resetFiltersToggler: props.resetFiltersToggler }}
        />
      );
    }
  );

  const inputsPlace = getInputs(filterInputs, ["place"])[0];
  const renderPlaceInputs = inputsPlace.fields!.map((input, key) => {
    let startingValue = "";

    Object.entries(filterCTX.place).forEach(([a, b]) => {
      if (a == input.name) {
        startingValue = b;
      }
    });

    return (
      <CustomInput
        key={key}
        {...input}
        defaultValue={startingValue}
        others={{
          setAction: props.byPlaceSetAction,
          selectAllToggler: props.selectAllPlaceToggler,
          resetToggler: props.resetFiltersToggler,
        }}
      />
    );
  });

  const placeHandler = () => {
    filterCTX.setIsPlaceOpen((prevState) => !prevState);
    placeToggler.toggle();
  };
  const featuresHandler = () => {
    filterCTX.setIsFeaturesOpen((prevState) => !prevState);
    featuresToggler.toggle();
  };
  const categoriesHandler = () => {
    filterCTX.setIsCategoriesOpen((prevState) => !prevState);
    categoriesToggler.toggle();
  };

  return (
    <div
      className="models-filter-box shadow"
      style={{
        width: isMobile ? "345px" : "",
        margin: isMobile ? "0 auto 20.5px" : "",
      }}
    >
      {/*  */}
      <div className="features-filter-box">
        <div className="features-filter-title-box">
          <p
            className="features-filter-title"
            style={{
              marginLeft: "22px",
              cursor: "pointer",
            }}
            onClick={placeHandler}
          >
            Place
          </p>
          <img
            className="features-filter-title-icon"
            src={`${toIcons}/${
              placeToggler.isToggled ? "small-up" : "small-down"
            }.svg`}
            alt=""
            onClick={placeHandler}
            style={{
              marginRight: "22px",
            }}
          />
        </div>

        {placeToggler.isToggled && (
          <div className="features-filter-inputs">
            {renderPlaceInputs}
            <p
              className="selectAll"
              onClick={props.selectAllPlaceToggler.toggle}
            >
              {props.selectAllPlaceToggler.isToggled ? "Deselect" : "Select"}{" "}
              All
            </p>
          </div>
        )}
      </div>
      <div className="divider-box" style={{ margin: "-20px auto" }}>
        <div
          className="divider"
          style={{
            width: isMobile ? "345px" : "",
          }}
        />
      </div>
      {/*  */}
      <div className="features-filter-box">
        <div className="features-filter-title-box">
          <p
            className="features-filter-title"
            style={{
              marginLeft: "22px",
              cursor: "pointer",
            }}
            onClick={featuresHandler}
          >
            Features
          </p>
          <img
            className="features-filter-title-icon"
            src={`${toIcons}/${
              featuresToggler.isToggled ? "small-up" : "small-down"
            }.svg`}
            alt=""
            onClick={featuresHandler}
            style={{
              marginRight: "22px",
            }}
          />
        </div>
        <form onChange={props.byParamsForm.handleSubmit(props.byParamsHandler)}>
          {featuresToggler.isToggled && (
            <div
              className="features-filter-inputs"
              style={{ margin: "0 10px" }}
            >
              {renderFeaturesRange}
            </div>
          )}
        </form>
        {featuresToggler.isToggled && (
          <div className="features-filter-inputs">
            <p className="features-eyes-title">Eyes</p>
            {renderFeaturesEyes}
            <p
              className="selectAll"
              onClick={props.selectAllEyesToggler.toggle}
            >
              {props.selectAllEyesToggler.isToggled ? "Deselect" : "Select"} All
            </p>
          </div>
        )}
        {featuresToggler.isToggled && (
          <div
            className="features-filter-inputs"
            style={{ marginBottom: "42px" }}
          >
            <p className="features-eyes-title">Hair</p>
            {renderFeaturesHair}
            <p
              className="selectAll"
              onClick={props.selectAllHairToggler.toggle}
            >
              {props.selectAllHairToggler.isToggled ? "Deselect" : "Select"} All
            </p>
          </div>
        )}
      </div>
      <div className="divider-box" style={{ margin: "-20px auto" }}>
        <div
          className="divider"
          style={{
            width: isMobile ? "345px" : "",
          }}
        />
      </div>
      <div className="features-filter-box">
        <div className="features-filter-title-box">
          <p
            className="features-filter-title"
            style={{
              marginLeft: "22px",
              cursor: "pointer",
            }}
            onClick={categoriesHandler}
          >
            Categories
          </p>
          <img
            className="features-filter-title-icon"
            src={`${toIcons}/${
              categoriesToggler.isToggled ? "small-up" : "small-down"
            }.svg`}
            alt=""
            onClick={categoriesHandler}
            style={{
              marginRight: "22px",
            }}
          />
        </div>
        <form
          onChange={props.byCategoriesForm.handleSubmit(
            props.byCategoriesHandler
          )}
        >
          <div
            style={{
              marginLeft: "12px",
            }}
          >
            {categoriesToggler.isToggled && (
              <div className="features-filter-inputs">
                {renderFeaturesCategories}
              </div>
            )}
          </div>
        </form>
      </div>
      <div
        className="divider-box"
        style={{ marginTop: categoriesToggler.isToggled ? "" : "-20px" }}
      >
        <div className="divider" style={{ width: isMobile ? "345px" : "" }} />
      </div>
      <p className="reset-filters" onClick={props.resetAllFilters}>
        Reset all filters
      </p>
    </div>
  );
};
export default ModelsFilter;
